import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function PowerCLIPasswordField({ powerCliPassword, anotherSectionActive, centralCredential, error, disabled }) {

    const [disableValue, setDisableValue] = useState(false)

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('powerCliPassword');
            onChange('');
        } 
        else if (centralCredential && centralCredential.id > 0) {
            validationService.cleanValidation('powerCliPassword');
            onChange('');
            setDisableValue(true);
        } 
        else {
            validationService.validateNotEmpty(powerCliPassword, 'powerCliPassword');
        }
        return () => validationService.cleanValidation('powerCliPassword');
    }, [powerCliPassword, anotherSectionActive, centralCredential])


    const onChange = (value) => modalDataService.changePowerCLIPassword(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="powercli_password">password</label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="powercli_password-key"
                    type="password"
                    disabled={disableValue}
                    value={powerCliPassword}
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("PowerCLIPaswordField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;

    return {
        powerCliPassword: addDeviceModal.powerCliPassword || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.powerCliPassword
    }
}

export default connect(mapStateToProps)(PowerCLIPasswordField);
